import React, { Component } from 'react';
// import PropTypes from 'prop-types'
import WithAuth from 'HOC/Auth/WithAuth';
import { withRouter } from 'react-router-dom';
import { Layout, Icon, message } from 'antd';

import styles from './Toolbar.module.css';
import Menu from './Menu/Menu';

const { Header } = Layout;

class Toolbar extends Component {
  state = {
    // current active menu
    currentActive: '',
  };

  // click handler for toolbar <ICON>
  onToolbarIconClick = () => {
    // redirect user to HomePage route
    this.props.history.push('/');
  };

  // click handler for toolbar <ITEM>
  onToolbarItemClick = event => {
    const { key } = event;
    // redirect user to HomePage route
    this.setState(prevState => ({ ...prevState, currentActive: key }));
    switch (key) {
      case 'Products':
        console.log(`Toolbar[${key}] clicked`);
        this.props.history.push('/products');
        break;
      case 'ProductTypes':
        console.log(`Toolbar[${key}] clicked`);
        this.props.history.push('/product_types');
        break;
      case 'Promotions':
        console.log(`Toolbar[${key}] clicked`);
        this.props.history.push('/promotions');
        break;
      case 'Admins':
        console.log(`Toolbar[${key}] clicked`);
        this.props.history.push('/admins');
        break;
      case 'History':
        console.log(`Toolbar[${key}] clicked`);
        this.props.history.push('/users');
        break;
      case 'Lists':
        console.log(`Toolbar[${key}] clicked`);
        this.props.history.push('/lists');
        break;
      case 'QRCodes':
        console.log(`Toolbar[${key}] clicked`);
        this.props.history.push('/qr_codes');
        break;
      case 'Inventory':
        this.props.history.push('/inventory');
        break;
      case 'Rooms':
        this.props.history.push('/rooms');
        break;
      case 'AppUser':
        this.props.history.push('/app_users');
        break;
      case 'Settings':
        this.props.history.push('/settings');
        break;
      case 'Logout':
        console.log(`Toolbar[${key}] clicked`);
        this.props.logout();
        this.props.history.push('/');
        message.info('Logged out', 1);
        break;
      default:
        return;
    }
  };

  ofuscateRoles = () => {
    const role = this.props.retrieveRole();
    let availableMenuItems = [];
    switch (role) {
      case 'SUPER':
        availableMenuItems = [
          'Products',
          'Inventory',
          'Product Types',
          'promotions',
          'QR codes',
          'lists',
          'admins',
          'rooms',
          'App User',
          'history',
          'settings',
          'logout',
        ];
        break;
      case 'STOCK':
        availableMenuItems = ['Products', 'Inventory', 'logout'];
        break;
      case 'SALES':
        availableMenuItems = ['Products', 'QR codes', 'lists', 'rooms', 'History', 'settings', 'logout'];
        break;
      default:
        availableMenuItems = [];
        break;
    }
    return availableMenuItems;
  };

  render() {
    return (
      <Header className={styles.Header}>
        <a onClick={this.onToolbarIconClick}>
          <Icon type="book" className={styles.Icon} />
        </a>
        <Menu
          onToolbarItemClick={this.onToolbarItemClick}
          current={this.state.currentActive}
          menuItems={this.ofuscateRoles()}
        />
      </Header>
    );
  }
}

export default withRouter(WithAuth(Toolbar));



// WEBPACK FOOTER //
// ./src/containers/Navigation/Toolbar/Toolbar.js